module.exports = __webpack_public_path__ + "img/magento-banner_medium.32a70cf3.jpg";